import request from '@/utils/request'

// 查询产品系列
export function getAllProductLine() {
  return request({
    url: 'app/product/getAllProductLine',
    method: 'get'
  })
}

// 查询产品类型
export function getAllProductType() {
  return request({
    url: 'app/product/getAllProductType',
    method: 'get'
  })
}

// 查询产品列表
export function getProductList(params) {
  return request({
    url: 'app/product/queryList',
    method: 'get',
    params: params
  })
}

// 查询产品类型详情
export function queryProductType(id) {
  return request({
    url: 'app/product/queryProductType/' + id,
    method: 'get'
  })
}

// 查询产品详情
export function getProductInfo(id) {
  return request({
    url: 'app/product/queryOne/' + id,
    method: 'get'
  })
}

// GET /app/product/getByPid
// 通过产品类型ID查询下级
export function getProductTypeByPid(id) {
  return request({
    url: 'app/product/getByPid',
    method: 'get',
    params: {
      pid: id
    }
  })
}


// WEBPACK FOOTER //
// ./src/api/product.js